/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../glyph/glyph_icon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "printable_check": {
                "nested": {
                  "PrintableCheckEducation": {
                    "fields": {
                      "instructions": {
                        "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckEducation.Instruction",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "disclaimerText": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Instruction": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckEducation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckEducation?.nested?.Instruction) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrintableCheckEducation @ squareup/bbfrontend/common/printable_check/printable_check_education.proto at 12:1
 */
export const PrintableCheckEducation = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckEducation');
fixType(PrintableCheckEducation, {
  instructions: {
    required: true
  },
  disclaimerText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PrintableCheckEducation);
/**
 * SOURCE Instruction @ squareup/bbfrontend/common/printable_check/printable_check_education.proto at 16:3
 */
PrintableCheckEducation.Instruction = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckEducation.Instruction');
fixType(PrintableCheckEducation.Instruction, {
  text: {
    notEmpty: true
  },
  icon: {
    required: true
  }
});
Builder.createAndAttachToType(PrintableCheckEducation.Instruction);